// Floji CSS Reset and Baseline styles, <Baseline /> should be
// included near the top level of any app using these floponents
import { createGlobalStyle } from "styled-components";
import { inIframe } from "../../utils/inIframe";



export const ShowOnLockScreenClass = "showOnLockScreen"



const Baseline = createGlobalStyle`

    html {  
        font-size: ${props => props.theme.typography.baseSize};
        overflow: hidden;
        text-size-adjust: none;
        height: 100%;
    }

    body { 
        background: ${props => inIframe() ? `none` : props.theme.palette.background};
        overflow: hidden;
        height: 100%;
        width: 100%;
        position: fixed; //on android chome, sometimes body is zero height (for instance on call ui
    }
    body.privacy #floji > * {
        display: none !important;
    }
    body .privacy #floji > .${ShowOnLockScreenClass} {
        display: block !important;
    }
    html, body, #floji {
        touch-action: pinch-zoom;
        overscroll-behavior: contain;
        overflow: hidden;
    }

    body.dialog_open {
        overflow: hidden
    }

    .noscrollbars{
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    
    .noscrollbars::-webkit-scrollbar {
        display: none;
    }

    // Apply theme colours to coloured icons
    svg > ._icoBrand {
        color: ${props => props.theme.palette.primary.main};
    }
    svg > ._icoPositive {
        color: ${props => props.theme.palette.positive.main};
    }
    svg > ._icoWarning {
        color: ${props => props.theme.palette.warning.main};
    }
    svg > ._icoDanger {
        color: ${props => props.theme.palette.danger.darker};
    }
`;

export default Baseline;
export { Baseline };
